(function($){$(function(){

    //console.log( 'locations-map', locations_data );

    // Load when script is ready
    var gm_check = setInterval(function(){
        if( typeof google !== 'undefined' && typeof google.maps !== 'undefined' ) {
            clearInterval( gm_check );
            init();
        }
    }, 500 );

    function init(){
        initMap(); // render map
        display_all_locations();
        showAllMarkers();
    }

    //Dark Theme
    const darkStyles = [

        // Global background
        {
            elementType: "geometry",
            stylers: [{ color: "#212121" }]
        },
        {
            elementType: "labels.icon",
            stylers: [{ visibility: "off" }]
        },
        {
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }]
        },
        {
            elementType: "labels.text.stroke",
            stylers: [{ color: "#212121" }]
        },

        // Administrative
        {
            featureType: "administrative",
            elementType: "geometry",
            stylers: [{ color: "#757575" }]
        },
        {
            featureType: "administrative.country",
            elementType: "labels.text.fill",
            stylers: [{ color: "#9e9e9e" }]
        },
        {
            featureType: "administrative.land_parcel",
            stylers: [{ visibility: "off" }]
        },
        {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{ color: "#bdbdbd" }]
        },

        // POI
        {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }]
        },
        {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{ color: "#181818" }]
        },
        {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{ color: "#616161" }]
        },

        // Roads
        {
            featureType: "road",
            elementType: "geometry.fill",
            stylers: [{ color: "#2c2c2c" }]
        },
        {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{ color: "#8a8a8a" }]
        },
        {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{ color: "#373737" }]
        },
        {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{ color: "#3c3c3c" }]
        },
        {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{ color: "#4e4e4e" }]
        },
        {
            featureType: "road.local",
            elementType: "geometry",
            stylers: [{ color: "#2c2c2c" }]
        },

        // Transit
        {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [{ color: "#757575" }]
        },
        {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{ color: "#2c2c2c" }]
        },
        {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{ color: "#2c2c2c" }]
        },

        // Water
        {
            featureType: "water",
            elementType: "geometry",
            stylers: [{ color: "#000000" }]
        },
        {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{ color: "#3d3d3d" }]
        }

    ]; //Dark Theme
    
    var map,
        geocoder,
        markers = [],
        infowindow;

    function initMap() {
      const map_defaults = {
        //center: { lat: -37.8136, lng: 144.9631  },
        center: { lat: -27.456127697018037, lng: 153.0467151164371  },
        zoom: 12,
        styles: darkStyles
      };

      map = new google.maps.Map(document.getElementById('locations-map'), map_defaults);
      geocoder = new google.maps.Geocoder();
      infowindow = new google.maps.InfoWindow();

      // MAIN BRANCH MARKER
        //renderMainBranchMarker(map_defaults.center);

      // Plot each location
      for (let i = 0; i < locations_data.length; i++) {
        const loc = locations_data[i];

        if (!loc.lat || !loc.lng) {
          const geocode_loc = loc;
          geocoder.geocode({ address: geocode_loc.address }, function (results, status) {
            if (status === google.maps.GeocoderStatus.OK) {
              renderMarker(geocode_loc, results[0].geometry.location);
              geocode_loc.lat = results[0].geometry.location.lat();
              geocode_loc.lng = results[0].geometry.location.lng();
            }
          });
        } else {
          renderMarker(loc, { lat: parseFloat(loc.lat), lng: parseFloat(loc.lng) });
        }
      }
    }
    // initMap

//Main Marker
// function renderMainBranchMarker(coordinates) {
//     const marker = new google.maps.Marker({
//         position: coordinates,
//         map: map,
//         title: 'Gigafy',
//         zIndex: 9999,
//         icon: {
//             url: site_data.theme_url + '/src/modules/locations/main/images/marker-main@2x.webp',
//             scaledSize: new google.maps.Size(40,54),
//             labelOrigin: new google.maps.Point(22, -10) // 👈 aligns text beside icon
//         },
//         label: {
//             text: 'Gigafy',
//             color: '#d90000',
//             fontSize: '16px',
//             fontWeight: '600',
//             className: 'map-main-label'
//         }
//     });

//     google.maps.event.addListener(marker, 'click', function () {
//         const content = estateHtml({
//             name: 'Gigafy – Main Branch',
//             item_map_link: 'https://maps.app.goo.gl/dkv7F2qkpcMsifRc7',
//             address: 'Head Office',
//         });

//         infowindow.setContent('<div class="info-window font-primary main-branch">' + content + '</div>');
//         infowindow.open(map, marker);
//         map.panTo(coordinates);
//     });
// }

//Markers
function renderMarker(data, coordinates) {
    const marker = new google.maps.Marker({
        position: coordinates,
        id: data.id,
        map: map,
        //icon: site_data.theme_url + '/src/modules/locations/main/images/marker-g.webp',
        icon: {
            url: site_data.theme_url + '/src/modules/locations/main/images/marker-g@2x.webp',
            scaledSize: new google.maps.Size(18,24),
        },
    });

    google.maps.event.addListener(marker, 'click', function () {
        // Pass the data directly to estateHtml
        const content = estateHtml({
            name: data.name || '',
            item_map_link: data.item_map_link || '#',
            image: data.image || '',
            phone: data.phone || '',
            email: data.email || '',
            address: data.address || '',
            office_hrs: data.office_hrs || ''
        });

        infowindow.setContent('<div class="info-window font-primary">' + content + '</div>');
        infowindow.open(map, this);
        map.panTo(coordinates);
    });

    markers.push(marker);
} // renderMarker

function estateHtml(data) {
    let s = '';

    s += '<div class="item-location-map">';

    if (data.image) {
        s += '<div class="s1">';
            s += '<div class="image image_fit">';
                s += '<img src="' + data.image + '" alt="' + data.name + '">';
            s += '</div>';
        s += '</div>';
    }

   
    s += '<div class="s2">';
        s += '<div class="s2-a">'; 
            s += '<h4 class="title limit-lines-2">';
                s += '<a href="' + data.item_map_link + '" target="_blank">' + data.name + '</a>';
            s += '</h4>';

            if (data.phone) {
                s += '<div class="phone"><a href="tel:' + data.phone + '">' + data.phone + '</a></div>';
            }

            if (data.address) {
                s += '<div class="address">' + data.address + '</div>';
            }

            if (data.office_hrs && Array.isArray(data.office_hrs)) {
                s += '<div class="hours">';
                    s += '<span class="hour-text">Hours</span>';
                    s += '<div class="h-inner">';
                        data.office_hrs.forEach(hour => {
                            s += '<span class="hour">' + hour.day + ' ' + hour.time + '</span>';
                        });
                    s += '</div>';
                s += '</div>';
            }
        s += '</div>'; 
        s += '<a href="' + data.item_map_link + '" class="view-more btn primary" target="_blank">View</a>';
    s += '</div>'; 


    

    s += '</div>'; 

    // Bottom
    // s += '<div class="location-agent">';
    //     s += '<div class="s1"><img src="/wp-content/themes/gigafy/images/svg/g-logo.svg"></div>';
    //     s += '<div class="s2">';
    //         s += '<span class="t1">Location Agent on Site</span>';
    //         s += '<span class="t2">Gigafy, guiding the way</span>';
    //     s += '</div>';
    // s += '</div>';

    return s;
}

    function display_all_locations() {
      let o = '';
      if (locations_data.length > 0) {
        for (let i = 0; i < locations_data.length; i++) {
          o += estateHtml(locations_data[i]);
        }
      } else {
        o += '<div class="item-location"><p>No location found.</p></div>';
      }
      $('.locations-search-results').html(o);
      $('.locations-search-results-container').addClass('active');
    }

    function showAllMarkers() {
        markers.forEach(function(marker) {
            marker.setMap(map);
        });
    }

    
})})(jQuery)